import { render, staticRenderFns } from "./CuratedPrograms.vue?vue&type=template&id=50db941a"
import script from "./CuratedPrograms.vue?vue&type=script&lang=js"
export * from "./CuratedPrograms.vue?vue&type=script&lang=js"
import style0 from "./CuratedPrograms.vue?vue&type=style&index=0&id=50db941a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports